<div class="hero-banner">
  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center py-5">
      <div
        class="spinner-border text-light"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  } @else {
    <div class="row g-0">
      <!-- Identity Risk Score (clickable, opens posture dialog) -->
      @if (identityScore(); as score) {
        <div
          class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--clickable"
          (click)="showScoreDetails.set(true)"
        >
          <div class="hero-metric__value">
            {{ score.current_score }}
            <span class="hero-metric__suffix">/100</span>
          </div>
          <div class="hero-metric__heading">
            <span class="hero-metric__label">Identity Risk Score</span>
            <span [class]="scoreBadgeClass()">{{ scoreBand() }}</span>
          </div>
          <div
            class="posture-bar mt-2"
            [class.posture-bar--critical]="scoreBand() === 'Critical'"
          >
            <div
              class="posture-bar__fill"
              [style.width.%]="score.current_score"
              [style.background-color]="scoreColor()"
            ></div>
          </div>
          @if (scoreCheckSummary()) {
            <div class="hero-metric__context">
              <span class="score-link">{{ scoreCheckSummary() }}</span>
            </div>
          }
        </div>
      } @else {
        <div class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--unavailable">
          <div class="hero-metric__value hero-metric__value--muted">N/A</div>
          <div class="hero-metric__label">Identity Risk Score</div>
          <div class="hero-metric__context">Data unavailable</div>
        </div>
      }

      @if (executiveMetrics(); as metrics) {
        <!-- High-Risk Identities -->
        <div
          class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--clickable"
          (click)="openKpiDetail.emit('high-risk')"
        >
          <div class="hero-metric__value">{{ metrics.high_risk_identities }}</div>
          <div class="hero-metric__label">High-Risk Identities</div>
          <div class="hero-metric__context">Current snapshot</div>
        </div>

        <!-- Privileged Accounts at Risk -->
        <div
          class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--clickable"
          (click)="openKpiDetail.emit('privileged-at-risk')"
        >
          <div class="hero-metric__value">{{ metrics.privileged_accounts_at_risk }}</div>
          <div class="hero-metric__label">Privileged Accounts at Risk</div>
          <div class="hero-metric__context">Current snapshot</div>
        </div>
      } @else {
        <div class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--unavailable">
          <div class="hero-metric__value hero-metric__value--muted">N/A</div>
          <div class="hero-metric__label">High-Risk Identities</div>
          <div class="hero-metric__context">Data unavailable</div>
        </div>

        <div class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--unavailable">
          <div class="hero-metric__value hero-metric__value--muted">N/A</div>
          <div class="hero-metric__label">Privileged Accounts at Risk</div>
          <div class="hero-metric__context">Data unavailable</div>
        </div>
      }

      <!-- Leaked Credentials (unrotated since detection) -->
      @if (leakedCredentialsUnavailable()) {
        <div class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--unavailable">
          <div class="hero-metric__value hero-metric__value--muted">N/A</div>
          <div class="hero-metric__label">Leaked Credentials</div>
          <div class="hero-metric__context">{{ leakedCredentialsContext() }}</div>
        </div>
      } @else {
        <div
          class="col-lg-3 col-md-6 col-12 hero-metric hero-metric--clickable"
          (click)="openKpiDetail.emit('leaked-credentials')"
        >
          <div class="hero-metric__value">{{ executiveMetrics()?.leaked_credentials ?? 0 }}</div>
          <div class="hero-metric__label">Leaked Credentials</div>
          <div class="hero-metric__context">{{ leakedCredentialsContext() }}</div>
        </div>
      }
    </div>

    <!-- Monitoring subtitle, and the only way into the monitored-identities list:
         the drilldown, its server-side paging and its API route were all built and
         nothing opened them. -->
    @if (executiveMetrics(); as metrics) {
      <div class="text-center mt-2 hero-subtitle">
        <button
          type="button"
          class="hero-subtitle__link score-link"
          (click)="openKpiDetail.emit('monitored-users')"
        >
          Monitoring {{ metrics.users_monitored }} identities -
          {{ metrics.core_identities }} Core Identities
        </button>
      </div>
    }
  }
</div>

<!-- Score Details Dialog -->
@if (showScoreDetails() && identityScore(); as score) {
  <app-score-details-dialog
    [scoreData]="score"
    (close)="showScoreDetails.set(false)"
    (tierChange)="tierChange.emit($event)"
  />
}
